import ContentIcon from "@/shared/ContentIcon";
import { MenuList, MenuVintage } from "./style";
import { useState } from "react";

const MenuHeaderVintage = () => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  return (
    <>
      <MenuVintage onClick={() => setIsMenuVisible(true)}>
        <ContentIcon
          fill="#555"
          width="21px"
          height="22px"
          nameIcon="bars-solid"
        />
      </MenuVintage>
      <MenuList className={isMenuVisible ? "menu-list isOpen" : "menu-list isClose"}>
        <div className="menu-close-button" onClick={() => setIsMenuVisible(false)}>
          <ContentIcon
            fill="#333"
            width="21px"
            height="22px"
            nameIcon="closeIco"
          />
        </div>
        <div className="menu-list-items">
          <a href="https://www.clarin80.com">Ver todas las notas</a>
          <a href="/">Volver</a>
        </div>
      </MenuList>
    </>
  );
};

export default MenuHeaderVintage;
